import React, { useState, useEffect } from "react";

export default function CookiePopup() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const lastConsent = localStorage.getItem("cookieConsentTime");

    if (!lastConsent) {
      // если согласия ещё не было → показываем
      setVisible(true);
    } else {
      const lastTime = new Date(parseInt(lastConsent, 10));
      const now = new Date();

      const hoursPassed = (now - lastTime) / (1000 * 60 * 60);

      if (hoursPassed >= 3) {
        setVisible(true);
      }
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookieConsentTime", Date.now().toString());
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-popup">
      <div className="cookie-popup__content">
        <p>
          Мы используем файлы cookie для улучшения работы сайта. Продолжая
          пользоваться сайтом, вы соглашаетесь с нашей{" "}
          <a
            href="/about/privacy"
            target="_blank"
            rel="noreferrer"
            className="question-answer-text"
          >
            политикой
          </a>{" "}
          использования cookie.
        </p>
        <button onClick={acceptCookies} className="cookie-popup__button">
          Согласиться
        </button>
      </div>
    </div>
  );
}
